var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 47,
    viewBox: "0 0 69 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.199 -4.47)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 47,
    rx: 7,
    transform: "translate(0.199 4.47)",
    fill: "#eaecf0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.033,418.279h-6.824c-1.143,0-1.558-.426-1.558-1.047a2.725,2.725,0,0,1,1.1-1.817,11.872,11.872,0,0,0,4.3.782c5.1,0,9.234-3.059,9.234-6.834s-4.137-6.834-9.234-6.834H167l3.507,4.229a5.32,5.32,0,0,0-.695,2.605c0,2.333,1.581,4.393,3.993,5.626-.07.04-.138.077-.2.109-1.915,1.01-3.626,2.543-3.626,4.887,0,1.59,1.005,4.5,5.823,4.5h6.547c1.386,0,2.145.466,2.145,1.668a2.353,2.353,0,0,1-2.6,2.443.718.718,0,0,0-.8.737c0,.582.588.814,1.212.814,4.711,0,7.032-3.335,7.032-6.359C189.342,420.412,187.16,418.279,182.033,418.279Zm-.552-8.726c0,3.218-.728,5-2.252,5-1.767,0-2.6-2.289-2.6-5.43,0-3.065.728-4.887,2.286-4.887C180.715,404.239,181.481,406.566,181.481,409.553Z",
    transform: "translate(-143.801 -388.06)",
    fill: "#5ec1a9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.0cd5606df73cfe02b0cc5d5f617627ee.svg";
export { ForwardRef as ReactComponent };